import Mainnav from "../components/Mainnav";
import Navbar from "../components/Navbar";
import WelcomeHeroSection from "../sections/welcome/WelcomeHeroSection";
import WelcomeTasksSection from "../sections/welcome/WelcomeTasksSection";

export default function WelcomePage() {
  return (
    <div>
      <Navbar />
      <div className={Classname.container}>
        <WelcomeHeroSection />
        <WelcomeTasksSection />
      </div>
    </div>
  );
}

const Classname = {
  container: "bg-gray-200 h-full flex flex-col gap-5 p-5 w-full items-center", 
};
